import { LayoutStyles } from '../types/ppt-slide';

const DEFAULT_TYPOGRAPHY = {
  title: {
    className: 'text-[min(4cqw,8cqh)] text-gray-200 font-semibold',
  },
  content: {
    className: 'text-[min(3.2cqw,6.4cqh)] text-gray-500 font-base',
  },
};

export const DEFAULT_LAYOUT_STYLES = {
  [LayoutStyles.QUADRANT]: {
    container: 'grid h-full grid-cols-2 grid-rows-2 gap-4',
    gridItem:
      'flex items-center justify-center rounded p-2 overflow-hidden',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3cqw,6cqh)] text-gray-500 font-base',
      },
    },
  },
  [LayoutStyles.COMPARISON]: {
    container: 'flex h-full flex-col gap-4 sm:flex-row',
    columnHeader: 'mb-3 text-center text-[min(3cqw,6cqh)] font-semibold',
    divider: '',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3cqw,6cqh)] text-gray-500 font-base',
      },
    },
  },
  [LayoutStyles.DEFAULT]: {
    container: 'flex h-full flex-col',
    wrapper: 'flex-1 whitespace-pre-wrap overflow-hidden',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
    },
  },
  [LayoutStyles.CENTERED_FOCUS]: {
    container: 'flex h-full items-center justify-center',
    wrapper: 'max-w-2xl whitespace-pre-wrap text-center overflow-hidden',
    typography: {
      title: {
        className: 'text-[min(3cqw,6cqh)] text-gray-200 font-normal',
      },
      content: {
        className: 'text-[min(3.5cqw,7cqh)] text-gray-500 mb-14 font-semibold',
      },
    },
  },
  [LayoutStyles.LEFT_CONTENT]: {
    container: 'flex h-full items-center justify-start px-2',
    wrapper: 'max-w-[45%] whitespace-pre-wrap text-center ml-4 mr-auto',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3.2cqw,6.4cqh)] text-gray-500 font-base text-center',
      },
    },
  },
  [LayoutStyles.RIGHT_CONTENT]: {
    container: 'flex h-full items-center justify-end px-2',
    wrapper: 'max-w-[45%] whitespace-pre-wrap text-center mr-4 ml-auto',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3.2cqw,6.4cqh)] text-gray-500 font-base text-center',
      },
    },
  },
  [LayoutStyles.HORIZONTAL_SPLIT]: {
    container: 'flex h-full flex-row gap-4',
    columnHeader: 'mb-3 text-center text-[min(3cqw,6cqh)] font-semibold',
    divider: '',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3cqw,6cqh)] text-gray-500 font-base',
      },
    },
  },
  [LayoutStyles.VERTICAL_SPLIT]: {
    container: 'flex h-full flex-col gap-4',
    columnHeader: 'mb-3 text-center text-[min(3cqw,6cqh)] font-semibold',
    divider: '',
    typography: {
      ...DEFAULT_TYPOGRAPHY,
      content: {
        className: 'text-[min(3cqw,6cqh)] text-gray-500 font-base',
      },
    },
  },
};
